/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsWithCampaignInfo } from '../models/NewsWithCampaignInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NewsService {

    /**
     * Get Last News
     * @returns NewsWithCampaignInfo Successful Response
     * @throws ApiError
     */
    public static getLastNews(): CancelablePromise<NewsWithCampaignInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/news/last',
        });
    }

}
